module.exports = __webpack_public_path__ + "static/media/plan-load-round.e98b120d.gif";